// @flow
export const scheduleType = {
    // product types
    ACTIVE_PLUG: 'ACTIVE_PLUG',
    COLOUR_TUNEABLE_LIGHT: 'COLOUR_TUNEABLE_LIGHT',
    COLOUR_LIGHT: 'COLOUR_LIGHT',
    HEATING: 'HEATING',
    HOT_WATER: 'HOT_WATER',
    NA_THERMOSTAT_COOL: 'NA_THERMOSTAT_COOL',
    NA_THERMOSTAT_DUAL: 'NA_THERMOSTAT_DUAL',
    NA_THERMOSTAT_HEAT: 'NA_THERMOSTAT_HEAT',
    TUNEABLE_LIGHT: 'TUNEABLE_LIGHT',
    WARM_WHITE_LIGHT: 'WARM_WHITE_LIGHT',
    THERMOSTAT: 'THERMOSTAT',
    NA_THERMOSTAT: 'NA_THERMOSTAT',
    // others
    RECIPE: 'RECIPE'
};

export const scheduleModesEnum = {
    ADD_EVENT: 'ADD_EVENT',
    COPY_DAY: 'COPY_DAY',
    DEFAULT: 'DEFAULT', // Changing events start & value
    DELETE_EVENT: 'DELETE_EVENT'
};

export const naThermostatScheduleEventKeys = {
    heat: 'heat',
    cool: 'cool'
};



// WEBPACK FOOTER //
// ./src/core/constants/schedule.js